import React from 'react';
import { PuffLoader } from 'react-spinners';
import { LoadingWrap } from './style';

export const LoadingIcon = () => (
  <LoadingWrap>
    <PuffLoader color="#c71b1b" size={280} />
  </LoadingWrap>
);
